import { fileSchema, requiredString } from '@/common/utils/zod';
import { z } from 'zod';

export const transportationCardFormSchema = z.object({
  number: requiredString,
  expiryDate: z.date({
    invalid_type_error: 'errors.input.required',
    required_error: 'errors.input.required',
  }),
  transportationCardFilesFront: fileSchema.nullable(),
  transportationCardFilesBack: fileSchema.nullable(),
});

export type TTransportationCardFormValues = z.infer<
  typeof transportationCardFormSchema
>;
